import { render, staticRenderFns } from "./ChangePasswordCompleteModule.vue?vue&type=template&id=280bdbd2&scoped=true&"
import script from "./ChangePasswordCompleteModule.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordCompleteModule.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordCompleteModule.vue?vue&type=style&index=0&id=280bdbd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280bdbd2",
  null
  
)

export default component.exports